import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import useRoles from 'hooks/useRoles';
import { Document, toDisplayDocument } from 'shared/models/site/document'
import { RelatedDocumentChips } from 'components/portal/documents/admin/RelatedDocuments';

import {
    Button
    , ModalBody
    , Row
    , Col
} from 'reactstrap';

import { BarChart } from '@mui/icons-material';
import { getUserExistingRulebookMode } from '../../../../shared/store/applicationState';


type DocumentDetailsProps = {
    document: Document,
    editDocument: (docId: number) => void,
    closeModal: () => void
}

export const DocumentDetails = (props: DocumentDetailsProps) => {
    const mode = getUserExistingRulebookMode();
    const roles = useRoles();
    const getPdfViewUrl = (docId: number | undefined) => `/pdf/view/${mode}/${docId}`;
    const displayDocument = toDisplayDocument(props.document);

    const editDocument = (docId: number | undefined) => {
        if (typeof docId === 'number') {
            props.editDocument(docId);
        }
    }

    return (
        <React.Fragment>

            <ModalBody className="pb-5 ml-4 document-info-body">

                <Row>
                    <Col><h3 className="header-row"><BarChart className="body-icon" />Document details: {props.document.documentNumber} {props.document.title}</h3></Col>
                </Row>
                <Row>
                    <Col className="col-4">Document type:</Col>
                    <Col>{displayDocument.typeLabel}{displayDocument.subTypeLabel == null ? "" : (`: ${displayDocument.subTypeLabel}`)}</Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Document title:</Col>
                    <Col>{displayDocument.title}</Col>
                </Row>
                <Row>
                    <Col className="col-4">Document number:</Col>
                    <Col>{displayDocument.documentNumber}</Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Version number:</Col>
                    <Col>{displayDocument.versionNumber}</Col>
                </Row>
                <Row>
                    <Col className="col-4 my-auto">Related documents:</Col>
                    <Col>{(displayDocument.relatedDocuments || []).length > 0 ? <RelatedDocumentChips documents={displayDocument.relatedDocuments || []} /> : <>N/A</>}</Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Published date:</Col>
                    <Col>{displayDocument.publishDateDisplay} {displayDocument.publishTime}</Col>
                </Row>
                <Row>
                    <Col className="col-4">Effective from date:</Col>
                    <Col>{displayDocument.effectiveFromDateDisplay} {displayDocument.effectiveFromTime}</Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Expiry date:</Col>
                    <Col>{displayDocument.expiryDateDisplay} {displayDocument.expiryTime}</Col>
                </Row>
                <Row>
                    <Col className="col-4">Acknowledgement and notfication:</Col>
                    <Col>{displayDocument.requiresAcknowledgementAndNotify ? "YES" : "NO"}</Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Review:</Col>
                    <Col>{displayDocument.reviewPeriodDisplay}</Col>
                </Row>
                <Row>
                    <Col className="col-4">Selected file:</Col>
                    <Col>
                        {displayDocument.file ? displayDocument.file.name : displayDocument.fileName || "Error!"}
                        <Link to={getPdfViewUrl(displayDocument.documentId)}><span className="ml-2 link-style">View</span></Link>
                    </Col>
                </Row>
                <Row className="alternate-row">
                    <Col className="col-4">Release notes:</Col>
                    <Col>{displayDocument.releaseNotes}</Col>
                </Row>
                <Row>
                    <Col className="col-4">Rescinding reason:</Col>
                    <Col>{displayDocument.rescindDocumentReason}</Col>
                </Row>

                {roles.isBOH &&
                    <div className="pt-5" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button onClick={() => editDocument(displayDocument.documentId)} className="btn-secondary info-edit-button pr-4 pl-4 m-4">Edit</Button>
                    </div>
                }

            </ModalBody>

        </React.Fragment >
    );
}
